import { OUTPUT_LANGUAGE_OPTIONS } from '@monetize/types/app';
import { ComponentProps, FC } from 'react';
import { MCustomSelect } from './MCustomSelect/MCustomSelect';

type MCustomSelectProps = ComponentProps<typeof MCustomSelect>;

interface LanguageLocaleDropdownProps extends Omit<
  MCustomSelectProps,
  'items' | 'itemTitle' | 'itemValue'
> {
  placeholder?: string;
}

export const LanguageLocaleDropdown: FC<LanguageLocaleDropdownProps> = ({
  placeholder = 'Select Language',
  ...rest
}) => {
  return (
    <MCustomSelect
      placeholder={placeholder}
      items={OUTPUT_LANGUAGE_OPTIONS}
      itemTitle="title"
      itemValue="value"
      showQueryInput
      {...rest}
    />
  );
};
